import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ModalController } from "@ionic/angular";
import { RegistrationModerationDetailModel } from "src/app/model/RegistrationModerationDetailModel";
import { RegistrationModerationDocumentModel } from "src/app/model/RegistrationModerationDocumentModel";
import { ModerationService } from "src/app/services/moderation.service";
import { ModerationDocumentComponent } from "../moderation-document/moderation-document.component";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-secure-moderation",
  templateUrl: "./moderation.component.html",
  styleUrls: ["./moderation.component.scss"],
})
export class ModerationComponent implements OnInit {
    isLoading: boolean = false;
    registrationModerationDetail: RegistrationModerationDetailModel;
    submitDisabled: boolean;
    
    constructor(private router: Router, private route: ActivatedRoute, private moderationService: ModerationService, 
        private modalCtrl: ModalController, private _snackBar: MatSnackBar, private sanitizer: DomSanitizer) { }
    
    ngOnInit(): void { 
        this.submitDisabled = false;
        this.route.params.subscribe((params: Params) => {
            const registrationModerationKey = +params['registrationModerationKey'];
            this.isLoading = true;
            this.moderationService.fetchModerationDetail(registrationModerationKey).subscribe(data => {
                this.registrationModerationDetail = data;
                this.isLoading = false;
            });
        });
    }
    
    async viewDocument(doc: RegistrationModerationDocumentModel) {
        const modal = await this.modalCtrl.create({
            component: ModerationDocumentComponent,
            cssClass: "Domicile,Caste Certificate,Caste Validity,Income Certificate,Income Certificate (Self),Income Certificate (Spouse),ITR (Self),ITR (Spouse), Gazetted Officers"
            .indexOf(doc.documentCode) < 0 ? 'master-modal' : 'master-modal-lg',
            componentProps: {
                registrationModerationDocument: {
                    ...doc,
                    registrationModerationStatus: this.registrationModerationDetail.moderationStatus,
                    checkerStatus: doc.checkerStatus,
                    applicantName: this.registrationModerationDetail.applicantName,
                    selectedCasteForMl: this.registrationModerationDetail.selectedCasteForMl,
                    casteCertficiateOcrBarcode: this.registrationModerationDetail.casteCertficiateOcrBarcode,
                    domicileOcrBarcode: this.registrationModerationDetail.domicileOcrBarcode,
                    casteValidityCertificateOcrBarcode: this.registrationModerationDetail.casteValidityCertificateOcrBarcode,
                    selfItrIncomeCertificateOcrBarcode: this.registrationModerationDetail.selfItrIncomeCertificateOcrBarcode,
                    spouseItrIncomeCertificateOcrBarcode: this.registrationModerationDetail.spouseItrIncomeCertificateOcrBarcode,
                    familyItrIncomeCertificateOcrBarcode: this.registrationModerationDetail.familyItrIncomeCertificateOcrBarcode,
                    selfItrAssessmentYear: this.registrationModerationDetail.selfItrAssessmentYear,
                    selfItrIncome: this.registrationModerationDetail.selfItrIncome,
                    spouseItrAssessmentYear: this.registrationModerationDetail.spouseItrAssessmentYear,
                    spouseItrIncome: this.registrationModerationDetail.spouseItrIncome,
                    panNumber: this.registrationModerationDetail.panNumber,
                    rwsSelfInc: this.registrationModerationDetail.rwsSelfInc,
                    rwsSpouseInc: this.registrationModerationDetail.rwsSpouseInc,
                    rwsFinancialYear: this.registrationModerationDetail.rwsFinancialYear,
                    rwsAssessmentYear: this.registrationModerationDetail.rwsAssessmentYear,
                    // originalDesignation: this.registrationModerationDetail.originalDesignation,
                    // curOrganizationName: this.registrationModerationDetail.curOrganizationName,
                    // designation: this.registrationModerationDetail.designation,

                }
            }
        });
        modal.present();

        const { data, role } = await modal.onWillDismiss();

        console.log('After submit modal data ',data);
        
        if (role === 'approve' || role === 'reject') {
            let actionDoc = this.registrationModerationDetail.moderationDocuments
                .find(rmd => rmd.registrationModerationDocumentKey === doc.registrationModerationDocumentKey);
            if (role === 'approve') {
                console.log(doc.documentCode, data);
                if('Income Certificate,Income Certificate (Self),Income Certificate (Spouse)'.
                indexOf(doc.documentCode) >=0) {
                    actionDoc.annualIncome = +data;
                }
                actionDoc.status = 'APPROVED';
                actionDoc.rejectRemarks = null;
                if(this.registrationModerationDetail.moderationStatus === 'MAKER_REJECTED') {
                    actionDoc.checkerStatus = 'APPROVED';
                }
            }
            else if (role === 'reject') {
                actionDoc.status = 'REJECTED';
                actionDoc.rejectRemarks = data;
                actionDoc.annualIncome = null;
                if(this.registrationModerationDetail.moderationStatus === 'MAKER_REJECTED') {
                    actionDoc.checkerStatus = 'REJECTED';
                }
            }
        } 
        else if(role === 'verify') {
            let actionDoc = this.registrationModerationDetail.moderationDocuments
                .find(rmd => rmd.registrationModerationDocumentKey === doc.registrationModerationDocumentKey);
            actionDoc.isDocReadable = data.isDocReadable;
            actionDoc.hasBarcode = data.hasBarcode;
            actionDoc.afterPeriod = data.afterPeriod;
            actionDoc.barcode = data.barcode;
            actionDoc.annualIncome = +data.annualIncome;
            actionDoc.rwsFinancialYear = data.rwsFinancialYear;
            actionDoc.rwsSelfInc = data.rwsSelfInc;
            actionDoc.rwsSpouseInc = data.rwsSpouseInc;
            
            if(actionDoc.docCode === 'DOMICILE') {
                if(data.isDocReadable === 'Y') {
                    if(data.hasBarcode === 'Y') {
                        if(data.afterPeriod === 'Y') {
                            actionDoc.status = 'APPROVED';
                            actionDoc.rejectRemarks = null;
                            actionDoc.rejectReasonSystem = null;
                        }
                        else if(data.afterPeriod === 'N') {
                            actionDoc.status = 'REJECTED';
                            actionDoc.rejectRemarks = null;
                            actionDoc.rejectReasonSystem = 
                            this.registrationModerationDetail.rejectReasonDocumentWise[actionDoc.docCode]
                            .find(r => r.configKey === 'Old Document');
                        }
                    }
                    else if(data.hasBarcode === 'N') {
                        actionDoc.status = 'REJECTED';
                        actionDoc.rejectRemarks = null;
                        actionDoc.rejectReasonSystem = 
                        this.registrationModerationDetail.rejectReasonDocumentWise[actionDoc.docCode]
                        .find(r => r.configKey === 'Old Document');
                    }
                }
                else if(data.isDocReadable === 'N') {
                    actionDoc.status = 'REJECTED';
                    actionDoc.rejectRemarks = null;
                    actionDoc.rejectReasonSystem = 
                    this.registrationModerationDetail.rejectReasonDocumentWise[actionDoc.docCode]
                    .find(r => r.configKey === 'Not a valid/clear domicile document');
                }
            }
            else if('INCOME_CERTIFICATE,INCOME_CERTIFICATE_SELF,INCOME_CERTIFICATE_SPOUSE'
            .indexOf(actionDoc.docCode) >= 0) {
                if(data.isDocReadable === 'Y') {
                    if(data.hasBarcode === 'Y') {
                        if(data.afterPeriod === 'Y') {
                            actionDoc.status = 'PENDING';
                            actionDoc.rejectRemarks = null;
                            actionDoc.rejectReasonSystem = null;
                        }
                        else if(data.afterPeriod === 'N') {
                            actionDoc.status = 'REJECTED';
                            actionDoc.rejectRemarks = "Income Certificate must be for financial year " + (actionDoc.rwsFinancialYear != null ? actionDoc.rwsFinancialYear : "2023-24") + " having barcode from MahaOnline/ MahaIT.";
                            actionDoc.rejectReasonSystem = null;
                            // this.registrationModerationDetail.rejectReasonDocumentWise[actionDoc.docCode]
                            // .find(r => r.configKey === 'Old Document');
                        }
                    }
                    else if(data.hasBarcode === 'N') {
                        actionDoc.status = 'REJECTED';
                        actionDoc.rejectRemarks = "Income Certificate must be for financial year " + (actionDoc.rwsFinancialYear != null ? actionDoc.rwsFinancialYear : "2023-24") + " having barcode from MahaOnline/ MahaIT.";
                        actionDoc.rejectReasonSystem = null;
                        // this.registrationModerationDetail.rejectReasonDocumentWise[actionDoc.docCode]
                        // .find(r => r.configKey === 'Old Document');
                    }
                }
                else if(data.isDocReadable === 'N') {
                    actionDoc.status = 'REJECTED';
                    actionDoc.rejectRemarks = "Incorrect/ Unclear document. Please upload Income Certificate issued by Tahasildar for financial year " + (actionDoc.rwsFinancialYear != null ? actionDoc.rwsFinancialYear : "2023-24") + " having barcode from MahaOnline/ MahaIT";
                    actionDoc.rejectReasonSystem = null;
                    // this.registrationModerationDetail.rejectReasonDocumentWise[actionDoc.docCode]
                    // .find(r => r.configKey === 'Wrong Document / ITR Uploaded / Unclear document ');
                    // actionDoc.rejectReason = "Incorrect/ Unclear document. Please upload Income Certificate issued by Tahasildar for financial year " + actionDoc.rwsFinancialYear + " having barcode from MahaOnline/ MahaIT";
                }
            }
            else if(actionDoc.docCode === 'ITR_SELF') {
                if(data.isDocReadable === 'Y') {
                    if(data.isAssessmentYearCorrect === 'Y') {
                        if(data.isIncomeCorrect === 'Y') {
                            actionDoc.status = 'APPROVED';
                            actionDoc.rejectRemarks = null;
                            actionDoc.rejectReasonSystem = null;
                        }
                        else if(data.isIncomeCorrect === 'N') {
                            actionDoc.status = 'REJECTED';
                            actionDoc.rejectRemarks = null;
                            actionDoc.rejectReasonSystem = 
                            this.registrationModerationDetail.rejectReasonDocumentWise[actionDoc.docCode]
                            .find(r => r.configKey === 'Wrong Income');
                        }
                    }
                    else if(data.isAssessmentYearCorrect === 'N') {
                        actionDoc.status = 'REJECTED';
                        actionDoc.rejectRemarks = null;
                        actionDoc.rejectReasonSystem = 
                        this.registrationModerationDetail.rejectReasonDocumentWise[actionDoc.docCode]
                        .find(r => r.configKey === 'Wrong Assessment Year');
                    }
                }
                else if(data.isDocReadable === 'N') {
                    actionDoc.status = 'REJECTED';
                    actionDoc.rejectRemarks = null;
                    actionDoc.rejectReasonSystem = 
                    this.registrationModerationDetail.rejectReasonDocumentWise[actionDoc.docCode]
                    .find(r => r.configKey === 'Not a valid/clear ITR document');
                }
            }
            else if(actionDoc.docCode === 'ITR_SPOUSE') {
                if(data.isDocReadable === 'Y') {
                    if(data.isAssessmentYearCorrect === 'Y') {
                        if(data.isIncomeCorrect === 'Y') {
                            actionDoc.status = 'APPROVED';
                            actionDoc.rejectRemarks = null;
                            actionDoc.rejectReasonSystem = null;
                        }
                        else if(data.isIncomeCorrect === 'N') {
                            actionDoc.status = 'REJECTED';
                            actionDoc.rejectRemarks = null;
                            actionDoc.rejectReasonSystem = 
                            this.registrationModerationDetail.rejectReasonDocumentWise[actionDoc.docCode]
                            .find(r => r.configKey === 'Wrong Income');
                        }
                    }
                    else if(data.isAssessmentYearCorrect === 'N') {
                        actionDoc.status = 'REJECTED';
                        actionDoc.rejectRemarks = null;
                        actionDoc.rejectReasonSystem = 
                        this.registrationModerationDetail.rejectReasonDocumentWise[actionDoc.docCode]
                        .find(r => r.configKey === 'Wrong Assessment Year');
                    }
                }
                else if(data.isDocReadable === 'N') {
                    actionDoc.status = 'REJECTED';
                    actionDoc.rejectRemarks = null;
                    actionDoc.rejectReasonSystem = 
                    this.registrationModerationDetail.rejectReasonDocumentWise[actionDoc.docCode]
                    .find(r => r.configKey === 'Not a valid/clear ITR document');
                }
            }
            else if(actionDoc.docCode === 'CASTE_CERTIFICATE') {
                if(data.isDocReadable === 'Y') {
                    if(data.hasBarcode === 'Y') {
                        actionDoc.status = 'APPROVED';
                        actionDoc.rejectRemarks = null;
                        actionDoc.rejectReasonSystem = null;
                    }
                    else if(data.hasBarcode === 'N') {
                        actionDoc.status = 'REJECTED';
                        actionDoc.rejectRemarks = null;
                        actionDoc.rejectReasonSystem = 
                        this.registrationModerationDetail.rejectReasonDocumentWise[actionDoc.docCode]
                        .find(r => r.configKey === 'Name or Caste Mismatch');
                    }
                }
                else if(data.isDocReadable === 'N') {
                    actionDoc.status = 'REJECTED';
                    actionDoc.rejectRemarks = null;
                    actionDoc.rejectReasonSystem = 
                    this.registrationModerationDetail.rejectReasonDocumentWise[actionDoc.docCode]
                    .find(r => r.configKey === 'Incorrect Document / Unclear document ');
                }
            }
            else if(actionDoc.docCode === 'CASTE_VALIDITY') {
                if(data.isDocReadable === 'Y') {
                    if(data.hasBarcode === 'Y') {
                        actionDoc.status = 'APPROVED';
                        actionDoc.rejectRemarks = null;
                        actionDoc.rejectReasonSystem = null;
                    }
                    else if(data.hasBarcode === 'N') {
                        actionDoc.status = 'REJECTED';
                        actionDoc.rejectRemarks = null;
                        actionDoc.rejectReasonSystem = 
                        this.registrationModerationDetail.rejectReasonDocumentWise[actionDoc.docCode]
                        .find(r => r.configKey === 'Name or Caste Mismatch');
                    }
                }
                else if(data.isDocReadable === 'N') {
                    actionDoc.status = 'REJECTED';
                    actionDoc.rejectRemarks = null;
                    actionDoc.rejectReasonSystem = 
                    this.registrationModerationDetail.rejectReasonDocumentWise[actionDoc.docCode]
                    .find(r => r.configKey === 'Incorrect Document / Unclear document ');
                }
            }
            // Added For Gazetted Officers
            else if(actionDoc.docCode === 'GAZETTED_OFFICERS') {
                if(data.isDocReadable === 'Y') {
                    // TODO
                    // console.log('modal data -> ',data?.originalDesignation);
                    // console.log('action data -> ',actionDoc);
                    actionDoc.status = 'APPROVED';
                    actionDoc.rejectRemarks = null;
                    actionDoc.rejectReasonSystem = null;
                    actionDoc.originalDesignation = data.originalDesignation;
                    actionDoc.designation = data.designation;
                    actionDoc.curOrganizationName = data.curOrganizationName;
                }
                else if(data.isDocReadable === 'N') {
                    console.log('Reject Call');
                    actionDoc.status = 'REJECTED';
                    actionDoc.rejectRemarks = null;
                    actionDoc.rejectReasonSystem = 
                    this.registrationModerationDetail.rejectReasonDocumentWise[actionDoc.docCode]
                    .find(r => r.configKey === 'Incorrect Document / Unclear document ');
                }
            }
            else if('PAP_VANSHAVALI,PAP_AWARD_COPY,PAP_METRO_CITY_DOCUMENT,MATHADI_KAMGAR,RELIGIOUS_MINORITY'.indexOf(actionDoc.docCode) >= 0) {
                if(data.isDocReadable === 'Y') {
                    actionDoc.status = 'APPROVED';
                    actionDoc.rejectRemarks = null;
                    actionDoc.rejectReasonSystem = null;
                }
                else if(data.isDocReadable === 'N') {
                    actionDoc.status = 'REJECTED';
                    actionDoc.rejectRemarks = null;
                    actionDoc.rejectReasonSystem = 
                    this.registrationModerationDetail.rejectReasonDocumentWise[actionDoc.docCode]
                    .find(r => r.configKey === 'Incorrect Document / Unclear document');
                    console.log('actionDoc.rejectReasonSystem', actionDoc.rejectReasonSystem);
                }
            }
        }
    }

    onSubmit() {
        this.isLoading = true;
        
        let verifyFlag = false;

        // console.log('submit registrationModerationDetail --> ' , this.registrationModerationDetail);
        // for(const rmd of this.registrationModerationDetail.moderationDocuments) {
        //     if(rmd.status === 'PENDING' || rmd.status === 'REJECTED' || rmd.status === 'APPROVED') {
        //         verifyFlag = true;
        //         break;
        //     }
        // }

        // if(verifyFlag) {
            this.moderationService.submitVerificationDetail(this.registrationModerationDetail).subscribe(data => {
                this.isLoading = false;
                if(data.status === 'SUCCESS') {
                    this.router.navigate(['/secure', 'moderation-list']);
                }
                else {
                    this._snackBar.open(data.errorMessage, "Close", {
                        horizontalPosition: "right",
                        verticalPosition: "top",
                        panelClass: "warning-toast",
                        duration: 3 * 1000,
                    });
                    this.submitDisabled = false;
                }
            }, error => {
                this.submitDisabled = false;
                this.isLoading = false;
                this._snackBar.open(error.errorMessage, "Close", {
                    horizontalPosition: "right",
                    verticalPosition: "top",
                    panelClass: "warning-toast",
                    duration: 3 * 1000,
                });
            });
        // }
        // else {
        //     this.submitDisabled = false;
        //     this._snackBar.open("Please Approve/ Reject at least one document", "Close", {
        //         horizontalPosition: "right",
        //         verticalPosition: "top",
        //         panelClass: "warning-toast",
        //         duration: 3 * 1000,
        //     });
        // }
    }

    sanitizeUrl(url) {
        if(url) {
            return this.sanitizer.bypassSecurityTrustResourceUrl('data:image;base64, '+url);
        }
        else {
            return "";
        }
    }
}